// ═══════════════════════════════════════════════════════════════════
// Nhãn + màu trạng thái đơn hàng (phía web).
//
// Bảng nhãn nằm ở @shoptrack/common/order-status (file thuần, không kéo
// pino/zod) để apps/admin dùng chung. Danh sách trạng thái chuẩn vẫn ở
// packages/common/src/orderStateMachine.ts (ORDER_STATUSES).
// ═══════════════════════════════════════════════════════════════════

export { STATUS_LABEL, statusMeta } from '@shoptrack/common/order-status'
export type { StatusIntent, StatusMeta } from '@shoptrack/common/order-status'

// ─── Phân loại trạng thái (gương của packages/common/orderStateMachine) ──
// Giữ đồng bộ thủ công với ORDER_STATUS_LEDGER_EFFECT / RETURNED_STATUSES
// / CANCELLED_STATUSES ở nguồn chuẩn.

/** HOÀN HÀNG — hàng đã gửi nhưng phải quay về. KHÔNG gồm đơn hủy. */
export function isReturnedStatus(status?: string | null): boolean {
  return status === 'hoan' || status === 'failed_shipment'
}

/** HỦY ĐƠN — đơn kết thúc mà hàng chưa từng lên đường. */
export function isCancelledStatus(status?: string | null): boolean {
  return status === 'huy' || status === 'draft_failed'
}

export type LedgerEffect = 'none' | 'pending' | 'settled' | 'reversed'

/**
 * Đơn ở trạng thái này còn sinh tiền không — chỉ theo trạng thái đơn (MOHINH_V2 §4.1).
 * Lưu ý 'huy' cũng ĐẢO như 'hoan'. Số tiền thật của từng đơn đọc ở `order.money`
 * (dòng tiền — xem components/orders/order-money.tsx), không suy từ trạng thái.
 */
export function ledgerEffectOf(status?: string | null): LedgerEffect {
  switch (status) {
    case 'giao-ok': return 'settled'
    case 'hoan':
    case 'huy': return 'reversed'
    case 'draft_failed':
    case 'hen-gio': return 'none'
    default: return 'pending'
  }
}

/**
 * Các trạng thái dùng làm bộ lọc trên trang danh sách đơn — một danh sách
 * duy nhất, thay vì mỗi trang tự viết lại một bộ `<option>` khác nhau.
 */
export const ORDER_FILTER_STATUSES = [
  'hen-gio',
  'cho-duyet',
  'cho-lay',
  'dang-giao',
  'giao-ok',
  'hoan',
  'huy',
] as const
